import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { gallery, galleryclose, left } from "../../../Helpers/Images"; // make sure path is correct
import "./Carousel.scss"; // <-- Import your CSS here
import OwlCarousel from "react-owl-carousel2";
import "../../../../common/css/owl.carousel.css";
import { isMobile } from "../../../../utils/util";

const Carousel = ({
  show,
  height,
  width,
  showBottomGallery,
  images,
  state,
  viewGalleries,
  room,
  carouselFor,
  showGallery,
}) => {
  const [imagesArray, setImagesArray] = useState([]);
  const [viewGallery, setViewGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  useEffect(() => {
    if (viewGallery) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [viewGallery]);
  if (!images || images.length === 0) return null;

  const carousel = {
    items: 1,
    loop: true,
    dots: !state?.isMobile || carouselFor === "package",
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    navText: [
      `<img src="${left}" alt="Prev" class="prev-button"/>`,
      `<img src="${left}" alt="Next" class="next-button"  />`,
    ],
  };

  const NextArrow = ({ onClick }) => (
    <div
      className="custom-arrow next-arrow"
      onClick={(ev) => {
        ev.stopPropagation();
        onClick();
      }}
    >
      <img src={left} alt="next" style={{ transform: "rotate(180deg)" }} />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="custom-arrow prev-arrow"
      onClick={(ev) => {
        ev.stopPropagation();
        onClick();
      }}
    >
      <img src={left} alt="prev" />
    </div>
  );

  const roomGalleries = (ev, room) => {
    ev.stopPropagation();
    if (!images) return;
    let imageArray = images;
    if (room) {
      const roomName = room.toLowerCase().trim();
      const filteredImages = images.filter((item) => {
        const label = item.label?.toLowerCase().trim();
        if (!label) return false;
        return (
          label.includes(roomName) ||
          label.includes("room") ||
          label.includes("rooms") ||
          label.includes("Room") ||
          label.includes("Rooms")
        );
      });
      imageArray = filteredImages.length > 0 ? filteredImages : images;
    }
    setImagesArray(imageArray);
    setViewGallery(true);
    if (showGallery) {
      showGallery(false);
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const closeGallery = () => {
    setViewGallery(false);
    if (showGallery) {
      showGallery(true);
    }
  };

  const prevNextImage = (position) => {
    let index = selectedImage;
    if (position === "previous") {
      index = selectedImage > 0 ? selectedImage - 1 : 0;
    } else {
      index =
        selectedImage < imagesArray.length - 1
          ? selectedImage + 1
          : imagesArray.length - 1;
    }

    setSelectedImage(index);
  };

  const imageSelection = (image) => {
    setSelectedImage(image);
  };

  let displayImages = [];

  if (carouselFor === "package") {
    const src = selectedImage ? imagesArray[selectedImage] : imagesArray[0];
    displayImages = [src];
  } else {
    const src = selectedImage
      ? imagesArray[selectedImage]?.url
      : imagesArray[0]?.url;
    displayImages = [{ url: src }];
  }

  return (
    <div
      className={`carousel-main ${
        carouselFor === "package" ? "action-visible" : "action-invisible"
      }`}
      style={{ width }}
    >
      <div style={{ height, position: "relative" }}>
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index}>
              <div
                className={`carousel-main__slide ${
                  carouselFor === "package" ? "pkg-slide" : ""
                }`}
                style={{ height }}
                onClick={(ev) =>
                  showBottomGallery && roomGalleries(ev, room.room_type_name)
                }
              >
                <img
                  src={carouselFor === "package" ? img : img.url}
                  alt={img.label || `slide-${index}`}
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          ))}
        </Slider>

        {showBottomGallery ? (
          <div
            className="carousel-main__gallerybtn"
            onClick={(ev) => roomGalleries(ev, room.room_type_name)}
          >
            Gallery <img src={gallery} alt="gallery" />
          </div>
        ) : (
          <div
            className="carousel-main__viewbtn"
            onClick={(ev) => roomGalleries(ev, room.room_type_name)}
          >
            View Gallery
          </div>
        )}
      </div>
      {viewGallery && (
        <div
          className="carousel-main__hotel-details-gallery"
          onClick={(ev) => ev.stopPropagation()}
        >
          <div
            onClick={() => closeGallery()}
            className="carousel-main__hotel-details-gallery__closebutton"
          >
            {" "}
            <img src={galleryclose} alt="closeicon" />
          </div>

          <div className="carousel-main__hotel-details-gallery__container">
            <div className="carousel-main__hotel-details-gallery__container__fullscreen">
              {!isMobile && (
                <div className="carousel-main__hotel-details-gallery__container__fullscreen__prev">
                  <img
                    onClick={() => {
                      prevNextImage("previous");
                    }}
                    src={left}
                    alt="prev-button"
                  />
                </div>
              )}

              <div className="carousel-main__hotel-details-gallery__container__fullscreen__image">
                <OwlCarousel options={carousel}>
                  {displayImages.map((img, index) => {
                    return (
                      <img
                        key={index}
                        src={carouselFor === "package" ? img : img.url}
                        alt="gallery"
                      />
                    );
                  })}
                </OwlCarousel>
                {isMobile && (
                  <img
                    className="carousel-main__hotel-details-gallery__container__fullscreen__image__next"
                    onClick={(ev) => {
                      ev.stopPropagation();
                      prevNextImage("previous");
                    }}
                    src={left}
                    alt="prev-button"
                  />
                )}
                {isMobile && (
                  <img
                    className="carousel-main__hotel-details-gallery__container__fullscreen__image__prev"
                    onClick={(ev) => {
                      ev.stopPropagation();
                      prevNextImage("next");
                    }}
                    src={left}
                    alt="next-button"
                  />
                )}
                {imagesArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="carousel-main__hotel-details-gallery__container__fullscreen__image__content"
                    >
                      {carouselFor !== "package" && (
                        <div className="carousel-main__hotel-details-gallery__container__fullscreen__image__content__description">
                          <h4>
                            {selectedImage
                              ? imagesArray[selectedImage]?.label
                              : item.label}
                          </h4>
                        </div>
                      )}

                      <div className="carousel-main__hotel-details-gallery__container__fullscreen__image__content__total">
                        <h4>
                          {`${
                            selectedImage !== "" &&
                            selectedImage < imagesArray.length
                              ? selectedImage + 1
                              : imagesArray.length
                          }/${imagesArray.length}`}
                        </h4>
                      </div>
                    </div>
                  );
                })}
              </div>
              {!isMobile && (
                <div className="carousel-main__hotel-details-gallery__container__fullscreen__next">
                  <img
                    onClick={(ev) => {
                      ev.stopPropagation();
                      prevNextImage("next");
                    }}
                    src={left}
                    alt="next-button"
                  />
                </div>
              )}
            </div>
            <div className="carousel-main__hotel-details-gallery__container__smallscreen">
              <div
                className={`carousel-main__hotel-details-gallery__container__smallscreen__slider `}
              >
                {imagesArray.map((item, index) => {
                  return (
                    <img
                      className={
                        selectedImage === index ? "selected_image" : ""
                      }
                      key={index}
                      onClick={(ev) => {
                        ev.stopPropagation();
                        imageSelection(index);
                      }}
                      src={carouselFor === "package" ? item : item.url}
                      alt={"gallery"}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Carousel;
